import { render, staticRenderFns } from "./GenAIUsageDashboard.vue?vue&type=template&id=e1d96c74&scoped=true&"
import script from "./GenAIUsageDashboard.vue?vue&type=script&lang=js&"
export * from "./GenAIUsageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GenAIUsageDashboard.vue?vue&type=style&index=0&id=e1d96c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d96c74",
  null
  
)

export default component.exports